export default __webpack_public_path__ + "static/faq3-e53899fb2b5716b5aa40503fcf7f1062.png";